var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloudOutline28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none",
  viewBox: "0 0 28 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.5 6C9.4624 6 7 8.4624 7 11.5c0 .2564.0175.5083.0512.7544a1 1 0 0 1-.6025 1.0573C5.0081 13.9185 4 15.3427 4 17c0 2.2091 1.7909 4 4 4h11c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5c-.0485 0-.0969.0007-.145.0021a1.0001 1.0001 0 0 1-1.0017-.7701C17.2811 7.8053 15.1002 6 12.5 6ZM5 11.5C5 7.3579 8.3579 4 12.5 4c3.2753 0 6.0584 2.0987 7.0813 5.0238C23.1753 9.3192 26 12.3298 26 16c0 3.866-3.134 7-7 7H8c-3.3137 0-6-2.6863-6-6 0-2.2246 1.2105-4.1646 3.0059-5.2004A7.6073 7.6073 0 0 1 5 11.5Z",
  clipRule: "evenodd"
})));
export { SvgCloudOutline28 as ReactComponent };